import { useCallback } from 'react';
import { useTemporaryValue } from '../../../contexts/field-temporary-value-context';
export const useSignatureValue = _ref => {
  let {
    value,
    target,
    onChange
  } = _ref;
  const [temporaryFile, setTemporaryFile] = useTemporaryValue(target);
  const signature = temporaryFile ? temporaryFile[0] : value == null ? void 0 : value[0];
  const handleChange = useCallback(newSignature => {
    if (newSignature) {
      onChange == null || onChange([newSignature]);
      setTemporaryFile([newSignature]);
    } else {
      onChange == null || onChange(null);
      setTemporaryFile(undefined);
    }
  }, [onChange, setTemporaryFile]);
  return {
    handleChange,
    signature
  };
};
//# sourceMappingURL=use-signature-value.js.map